<template>
	<CreationWizardListItemRow
		class="tool-placement-row"
		:title="tool.title"
		:icon="tool.toolIcon"
		:description="tool.description"
		:descriptionInNewLine="tool.descriptionInNewLine"
	>
		<template v-if="tool.toolIcons" #icon>
			<div class="display-flex flex-wrap flex-column py-2">
				<div class="flex-col-12" v-for="toolIcon in tool.toolIcons" :key="toolIcon">
					<SIcon :name="toolIcon" height="20" width="20" />
				</div>
			</div>
		</template>
	</CreationWizardListItemRow>
</template>

<script>
import CreationWizardListItemRow from '../common/CreationWizardListItemRow.vue';
export default {
	name: 'ToolPlacementRow',
	props: { tool: { type: Object } },
	components: { CreationWizardListItemRow },
};
</script>

<style lang="scss" scoped></style>
